import { i18n } from '@/locales';
const { t } = i18n;
const lc = 'views.worker_management.';
// 나열순서 유지필요
// notion.so/barogohq/employeeType-ae67204398a848b5b542becced645e94?pvs=4#ee3955d64ef049949ef811df40b35f06
const employeeTypeCode = [
    'FULL_TIME',
    'SPECIAL',
    // 특수고용직(고용보험제외자)
    'SPECIAL_EMPLOYMENT_INSURANCE_EXCLUSION',
    'HUB_OWNER',
];
const result = {};
employeeTypeCode.forEach((code, index) => {
    result[code] = {
        text: t(`${lc}worker_employee_type_code_text[${index}]`),
        value: code,
        field: code,
    };
});
// 라이더 관리 - 근무정보
export default result;
